import React from 'react';
import { Button } from 'antd';


export default class SFButton extends React.Component {
    render() {
        return (
            <Button htmlType="button" {...this.props}>{this.props.children}</Button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/SFButton.js